export const updateKRConst = {
    INITIAL_UPDATE_KR_PROPS: 'INITIAL_UPDATE_KR_PROPS',
    UPDATE_CONFIDENCE: 'UPDATE_CONFIDENCE',
    UPDATE_METRIC_CONFIDENCE: 'UPDATE_METRIC_CONFIDENCE'
}